import { render, staticRenderFns } from "./GroupRoleDisplay.vue?vue&type=template&id=230693b6&"
import script from "./GroupRoleDisplay.vue?vue&type=script&lang=ts&"
export * from "./GroupRoleDisplay.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports